
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="p" components={components}>{`Empörung überschwemmt die sozialen Medien und vergiftet den gesellschaftlichen Diskurs. Und natürlich sind immer die anderen schuld: Coronaskeptiker, Klimaleugner, Wutbürger. Aber – Hand aufs Herz – wie steht es um Ihre persönliche Empörungsanfälligkeit? In unserem Selbsttest finden Sie es heraus. Bitte geben Sie an, inwieweit die Aussagen auf Sie zutreffen. Sie erhalten ein durch die psychologische Forschung gestütztes Feedback. Ihre Daten werden anonym behandelt.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  